import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Box, Link, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu"; 
import CustomPopperNavBar from "../componentes/poppers/Custom_popper_navbar"
import axiosInstancePromise from "../general/axiosConfig";
import { use } from "react";
import { styleImage } from '../estilo/Main';

const NavBar = ({ showLinks = false, showLoginButton = false }) => {
  const [cajamodal, setCajaModal] = useState([]);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [filas, setFilas] = useState([]);
  const [logoEmpresa, setLogoEmpresa] = useState(null);
  const [paginaURL, setPaginaURL] = useState('');
  const [paginaURLBILL, setPaginaURLBILL] = useState('');

  useEffect(() => {
    const fetchCampos = async () => {
      try {
       const axiosInstance = await axiosInstancePromise;
       const response = await axiosInstance.get(`/get-table-general/general_config`);
       const allRows = response.data.rows || [];
       setFilas(allRows);

       if (allRows.length > 0) {
        const logo = allRows[0]['logotipo'] || ''
        setLogoEmpresa(logo);
        const paginaOfi = allRows[0]['pagina_ofi'] || '';
        const paginaURLFinal = paginaOfi?.startsWith('http')? paginaOfi : `https://${paginaOfi}`;
        const paginaURLBILL2 = paginaOfi?.startsWith('http')? '' : `https://billitright.co`;
        setPaginaURL(paginaURLFinal);
        setPaginaURLBILL(paginaURLBILL2);
       }
      } catch (error) {
       console.error("Error al cargar los campos de la configuración general", error);
      }  
    };
    fetchCampos();
  }, []);
  const opcMenu = [
    { id: "ConfiguracionMenu", label: "Configuración" },
    { id: "CerrarSesion", label: "Cerrar Sesión" },
  ];

  const handleMenuClic = (event) => {
    setCajaModal(opcMenu);
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const isImageValid = (src) => {
    if (!src) return false;
    if (src === 'logo_3-removebg-preview.png' || src === 'undefined' || src === 'null') return false;
    if (!/\.(png|jpg|jpeg|gif|svg)$/i.test(src)) return false;
    return true;
  };

  console.log(logoEmpresa);
  
  return (
    <AppBar position="fixed" sx={{ bgcolor: 'white' }}>
      <Toolbar>
        <a href={paginaURLBILL} target="_blank" rel="noopener noreferrer"> 
          <Box component={"img"} src="/LOGOKAI-FAVICON-02.png"
            alt="Logo KAI" sx={styleImage} />
        </a>
        {/* {isImageValid(logoEmpresa) && (
          <a href={paginaURL} target="_blank" rel="noopener noreferrer">
            <Box component={"img"} src={`/${logoEmpresa}`}
              alt="Logo empresa cliente de KAI" sx={styleImage} />
          </a>
        )} */}
        <Box sx={{ flexGrow: 1 }} />
        {showLinks && (
          <>
            <Link href="#features" color="#121212" underline="none" sx={{ mx: 2 }}>
              Características
            </Link>
            <Link href="#testimonials" color="inherit" underline="none" sx={{ mx: 2 }}>
              Testimonios
            </Link>
          </>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
          <IconButton aria-label="notifications" sx={{ color: '#121212' }} onClick={handleMenuClic} >
            <MenuIcon/>
          </IconButton>
          <CustomPopperNavBar open={open} anchorEl={anchorEl}
            cajamodal={cajamodal} handleClose={handleClose}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
